import { useSelector } from "react-redux";
import { HotelsShopSelectors } from "@b2bportal/core-hotels";
import { useModuleBEM } from "@b2bportal/core-themes";
import styles from "./PackageHotelShopPriceSummary.module.scss";
import { PackagePriceSummary } from "@/pages/Packages/components/PackagePriceSummary";
import { PackageHotelShopSelectors } from "@/store/packages";

export const PackageHotelShopPriceSummary = () => {
  const [block] = useModuleBEM(styles, "PackageHotelShopPriceSummary");

  const { data: roomProduct } = useSelector(
    HotelsShopSelectors.getCheapestRoomProduct
  );
  const packagesByRateId = useSelector(
    PackageHotelShopSelectors.getPackagesByRateId
  );
  const rateId = roomProduct?.rateId?.value;
  const price = packagesByRateId?.[rateId]?.price;

  return (
    <div className={block}>
      <PackagePriceSummary price={price} />
    </div>
  );
};
